<template>
  <div id="LanguageSelector">
    <button @click="selectLanguage('en')" :class="{active: lang === 'en'}">English</button>
    <button @click="selectLanguage('fr')" :class="{active: lang === 'fr'}">Français</button>
  </div>
</template>
<script>
export default {
  name: 'LanguageSelector',
  data () {
    return {
      lang: this.$route.params.lang || this.$i18n.locale.toLowerCase()
    }
  },
  watch: {
    lang () {
      this.$router.replace({name: this.$route.name, params: {lang: this.lang}})
    }
  },
  methods: {
    selectLanguage (language) {
      this.lang = language
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/mixins';

#LanguageSelector {
  background: $white;
  display: flex;
  flex-direction: row;
  border-top: 1px solid #e7e6e6;
  button {
    flex: 1;
    background: $white;
    opacity: .3;
    color: $black;
    height: 48px;
    border: none;
    cursor: pointer;
    font-size: px2rem(10);
    @media(min-width: $screen-sm-min) {
      font-size: px2rem(13);
    }
    text-transform: uppercase;
    &:first-child {
      border-right: 1px solid #e7e6e6;
    }
    &.active {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue